//libraries
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import axios from 'axios';

//js
import { getDevId } from '../assets/sec/getDevId';
import { lightBlueThemeColor } from '../assets/colors-setup';


export function Landing({deviceType})
{
      const navigate=useNavigate();


      useEffect(()=>
      {
            //sending usageStats
            (async function()
            {
                  axios.post('/sendUsageStats', { devId: await getDevId() });
            })();


            //showing logo animation
            const animTime=(deviceType==='webview') ? 0 : 2000;

            setTimeout(()=>
            {
                  if(deviceType==='webview') return navigate('/home');

                  // return navigate('/start');
                  
                  return navigate('/home');
            },
            animTime);


            //changing background color
            document.querySelector('body').style.backgroundColor='white';
            return ()=> document.querySelector('body').style.backgroundColor=lightBlueThemeColor;
      },
      []);


      if(deviceType!='webview') return<>
            <div className='d-flex flex-column justify-content-center' style={{width: '100%', height: '100%', position: 'fixed'}}>
                  <div className="animate__animated animate__zoomIn     text-center mx-3 mx-sm-0">
                        <img className="img-fluid" src={require('../assets/logo.jpg')} alt="MyXAcademy" />
                  </div>
            </div>
      </>;
};
